"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PAGE_HEADER_HEIGHT", {
  enumerable: true,
  get: function get() {
    return _PageHeader2.PAGE_HEADER_HEIGHT;
  }
});
exports["default"] = void 0;
var _PageHeader = _interopRequireDefault(require("./PageHeader"));
var _PageHeader2 = require("./PageHeader.styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = _PageHeader["default"];